// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ProviderType } from "../../data/messaging/provider-type";
import { GatewayProvider } from "../../data/messaging/gateway-provider";
import { GatewayProviderProviderType } from "../../data/messaging/gateway-provider-provider-type";
import { TextMessageDocument } from "./documents/text-message-document";
import { ItemEnvelope } from "./base/item-envelope";

export class TextMessageEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "TextMessage");
		if (jsonEnvelope) {
			this.ProviderTypesPool = jsonEnvelope.ProviderTypesPool;
			this.GatewayProvidersPool = jsonEnvelope.GatewayProvidersPool;
			this.GatewayProviderProviderTypes = jsonEnvelope.GatewayProviderProviderTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public ProviderTypesPool: ProviderType[] = [];
	public GatewayProvidersPool: GatewayProvider[] = [];
	public GatewayProviderProviderTypes: GatewayProviderProviderType[] = [];
	public override Document: TextMessageDocument = new TextMessageDocument();
	public override get ItemId(): number { return this.Document.Item.TextMessageId; }
	public override get ItemName(): string { return this.Document.Item.Body; }
}